import { FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../../App/AppContext';
import { getAllDropdowns, getScheduleEventsById, postScheduleEvents } from '../../../Core/Service/vmrs-service';
import { Multiselect, NoButton, SecondaryButton, SelectBox, TextBox, YesButton } from '../../../Core/FormInput';

const firstEventList = [
    { id: 1, name: 'Date From First Registration' },
    { id: 2, name: 'Date From Initial Certificate' }
];

const nextEventList = [
    { id: 1, name: 'Fixed Interval' },
    { id: 2, name: 'Date From Last Event' }
];

const ScheduleEventDialog = (props) => {
    const [selectedData, setSelectedData] = useState({
        multi: []
    });
    const [state, setState] = useState({
        scheduleEventName: '',
        scheduleEventInterval: '',
        scheduleEventTimeToFirst: '',
        scheduleEventMilesDue: '',
        scheduleEventFirstEvent: '',
        scheduleEventNextEvent: '',
        scheduleEventDayRange: '',
        vmrsCategory: '',
        vmrsSubCategory: '',
        nominalCode: null,
        scheduleEventInternalType: '',
        eventDocsIds: null,
        dropList: [],
        scheduleEventIntervalPeriodCode: '',
        scheduleEventDisplayInspectionLink: '',
        scheduleEventDisplayResult: false,
        allowedDayRangeList: [],
        scheduleEventInspectionTypeID: null,
        scheduleEventStandardLineIDValue: null,
        scheduleEventStandardLineID: null,
        scheduleEventDisplayPreviousDefects: false,
        scheduleEventCopyTyreData: false,
        scheduleEventCreateNewEvent: false,
        scheduleEventIs2ndSignOffRequired: false,
        scheduleEventLinkedEventID: null,
        scheduleEventStartEventLabel: '',
        scheduleEventEndEventLabel: '',
        scheduleEventDisplayCustomerDeclaration: null,
        customerDeclarationList: [
            { id: 0, name: 'None' },
            { id: 1, name: 'Onhire Declaration' },
            { id: 2, name: 'Offhire Declaration' }
        ]
    });
    const [errors, setErrors] = useState({});
    const { showToast } = useContext(AppContext);

    const [btnLoader, setBtnLoader] = useState(false);

    const pullDropList = async () => {
        try {
            const res = await getAllDropdowns();
            if (res && res.data) {
                setState((st) => ({ ...st, dropList: res.data }));
            }
        } catch (err) {
            // keep UI responsive and show a toast if available
            showToast && showToast(err.message || 'Failed to load dropdowns');
        }
    };

    useEffect(() => {
        let mounted = true;
        const init = async () => {
            try {
                if (props.selectedRowData?.scheduleEventID) {
                    const res = await getScheduleEventsById(props.selectedRowData.scheduleEventID);
                    // const temp = res?.data || {};
                    const temp = res.data.details[0] || {};
                    const documents = res.data.documents || [];
                    if (!mounted) return;
                    setState((st) => ({
                        ...st,
                        scheduleEventID: temp.scheduleEventID,
                        scheduleEventName: temp.scheduleEventName,
                        scheduleEventInterval: temp.scheduleEventInterval,
                        scheduleEventTimeToFirst: temp.scheduleEventTimeToFirst,
                        scheduleEventMilesDue: temp.scheduleEventMilesDue,
                        scheduleEventFirstEvent: temp.scheduleEventFirstEvent,
                        scheduleEventNextEvent: temp.scheduleEventNextEvent,
                        scheduleEventDayRange: temp.scheduleEventDayRange,
                        vmrsCategory: temp.vmrsCategory,
                        vmrsSubCategory: temp.vmrsSubCategory,
                        nominalCode: temp.nominalCode,
                        scheduleEventInternalType: temp.scheduleEventInternalType,
                        eventDocsIds: documents || [],
                        scheduleEventIntervalPeriodCode: temp.scheduleEventIntervalPeriodCode,
                        scheduleEventDisplayInspectionLink: temp.scheduleEventDisplayInspectionLink,
                        scheduleEventDisplayResult: temp.scheduleEventDisplayResult,
                        scheduleEventReminderInterval: temp.scheduleEventReminderInterval,
                        scheduleEventReminderMilesDue: temp.scheduleEventReminderMilesDue,
                        scheduleEventReminderPeriodCode: temp.scheduleEventReminderPeriodCode,
                        scheduleEventCreateNewEvent: temp.scheduleEventCreateNewEvent,
                        scheduleEventInspectionTypeID: temp.scheduleEventInspectionTypeID,
                        scheduleEventStandardLineID: temp.scheduleEventStandardLineID,
                        scheduleEventDisplayPreviousDefects: temp.scheduleEventDisplayPreviousDefects,
                        scheduleEventCopyTyreData: temp.scheduleEventCopyTyreData,
                        scheduleEventIs2ndSignOffRequired: temp.scheduleEventIs2ndSignOffRequired ?? false,
                        scheduleEventLinkedEventID: temp.scheduleEventLinkedEventID,
                        scheduleEventStartEventLabel: temp.scheduleEventStartEventLabel,
                        scheduleEventEndEventLabel: temp.scheduleEventEndEventLabel,
                        scheduleEventDisplayCustomerDeclaration: temp.scheduleEventDisplayCustomerDeclaration
                    }));
                }
            } catch (error) {
                showToast && showToast(error.message || 'Failed to load schedule event');
            } finally {
                // always attempt to load dropdowns even if schedule fetch fails
                pullDropList();
            }
        };
        init();
        return () => {
            mounted = false;
        };
    }, [props.selectedRowData]);

    useEffect(() => {
        if (state.eventDocsIds && Array.isArray(state.dropList?.eventDocs)) {
            const a = state.eventDocsIds.map((i) => Number(i));
            const selectedModule = state.dropList.eventDocs.filter((w) => a.indexOf(w.id) > -1);
            setSelectedData((st) => ({ ...st, multi: selectedModule }));
        }
    }, [state.dropList, state.eventDocsIds]);

    useEffect(() => {
        if (state.vmrsCategory && Array.isArray(state.dropList?.vmrsSubCategory)) {
            const subModule = state.dropList.vmrsSubCategory.filter((x) => x.vmrsCategory == state.vmrsCategory);
            setState((st) => ({ ...st, vmrsSubCategoryList: subModule }));
        }
    }, [state.dropList, state.vmrsCategory]);

    useEffect(() => {
        const arr = Array.isArray(state.dropList?.allowedDayRange) ? state.dropList.allowedDayRange : [];
        const subModule = arr.map((x) => ({ id: x.allowedDayRangeID, name: x.allowedDayRangeDescription }));
        setState((st) => ({ ...st, allowedDayRangeList: subModule }));
    }, [state.dropList]);

    const multiChange = (_e, value) => {
        setSelectedData((st) => ({ ...st, multi: value }));
        setState((st) => ({ ...st, eventDocsIds: value?.map((c) => c.id) }));
    };

    const validate = () => {
        let noErrors = true;
        let err = {};
        if (!/[^\s]/.test(state.scheduleEventName)) {
            err.scheduleEventName = true;
            noErrors = false;
        }

        if (+state.scheduleEventTimeToFirst < 0) {
            err.scheduleEventTimeToFirstN = true;
            noErrors = false;
        } else if (!/[^\s]/.test(state.scheduleEventTimeToFirst)) {
            err.scheduleEventTimeToFirst = true;
            noErrors = false;
        }

        if (!/[^\s]/.test(state.scheduleEventDayRange)) {
            err.scheduleEventDayRange = true;
            noErrors = false;
        }

        if (!(/[^\s]/.test(state.scheduleEventInterval) || /[^\s]/.test(state.scheduleEventMilesDue))) {
            // fallback if both empty
            err.bothNeeded = true;
            noErrors = false;
        } else {
            if (state.scheduleEventInterval !== '' && +state.scheduleEventInterval < 0) {
                err.scheduleEventIntervalN = true;
                noErrors = false;
            }
            if (state.scheduleEventMilesDue !== '' && +state.scheduleEventMilesDue < 0) {
                err.scheduleEventMilesDueN = true;
                noErrors = false;
            }
        }
        if (!/[^\s]/.test(state.scheduleEventFirstEvent)) {
            err.scheduleEventFirstEvent = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.scheduleEventNextEvent)) {
            err.scheduleEventNextEvent = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.vmrsCategory)) {
            err.vmrsCategory = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.vmrsSubCategory)) {
            err.vmrsSubCategory = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.scheduleEventInternalType)) {
            err.scheduleEventInternalType = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.scheduleEventIntervalPeriodCode)) {
            err.scheduleEventIntervalPeriodCode = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.scheduleEventStartEventLabel) && state.scheduleEventLinkedEventID) {
            err.scheduleEventStartEventLabel = true;
            noErrors = false;
        }
        if (!/[^\s]/.test(state.scheduleEventEndEventLabel) && state.scheduleEventLinkedEventID) {
            err.scheduleEventEndEventLabel = true;
            noErrors = false;
        }
        setErrors(err);
        return noErrors;
    };

    const handleData = async () => {
        const isValid = validate();
        if (!isValid) return;

        setBtnLoader(true);
        try {
            const response = await postScheduleEvents({
                scheduleEventID: state.scheduleEventID || null,
                scheduleEventTimeToFirst: +state.scheduleEventTimeToFirst,
                scheduleEventInterval: +state.scheduleEventInterval,
                scheduleEventMilesDue: +state.scheduleEventMilesDue,
                scheduleEventInternalType: state.scheduleEventInternalType,
                scheduleEventFirstEvent: state.scheduleEventFirstEvent || null,
                scheduleEventName: state.scheduleEventName,
                scheduleEventNextEvent: state.scheduleEventNextEvent || null,
                vmrsCategory: state.vmrsCategory || null,
                vmrsSubCategory: state.vmrsSubCategory || null,
                // nominalCode: state.nominalCode || '',
                scheduleEventDayRange: +state.scheduleEventDayRange,
                eventDocsIds: state.eventDocsIds?.length > 0 ? state.eventDocsIds : null,
                scheduleEventIntervalPeriodCode: state.scheduleEventIntervalPeriodCode,
                scheduleEventDisplayInspectionLink: state.scheduleEventDisplayInspectionLink,
                scheduleEventDisplayResult: state.scheduleEventDisplayResult,

                scheduleEventReminderInterval: state.scheduleEventReminderInterval,
                scheduleEventReminderMilesDue: state.scheduleEventReminderMilesDue,
                scheduleEventReminderPeriodCode: state.scheduleEventReminderPeriodCode,
                scheduleEventCreateNewEvent: state.scheduleEventCreateNewEvent,
                scheduleEventInspectionTypeID: state.scheduleEventInspectionTypeID,
                scheduleEventStandardLineID: state.scheduleEventStandardLineID,
                scheduleEventDisplayPreviousDefects: state.scheduleEventDisplayPreviousDefects,
                scheduleEventCopyTyreData: state.scheduleEventCopyTyreData,
                scheduleEventIs2ndSignOffRequired: state.scheduleEventIs2ndSignOffRequired,
                scheduleEventLinkedEventID: state.scheduleEventLinkedEventID,
                scheduleEventStartEventLabel: state.scheduleEventStartEventLabel,
                scheduleEventEndEventLabel: state.scheduleEventEndEventLabel,
                scheduleEventDisplayCustomerDeclaration: state.scheduleEventDisplayCustomerDeclaration
            });

            if (response) {
                if (response.success) {
                    showToast &&
                        showToast(props.selectedRowData?.scheduleEventID ? 'Schedule Events updated successfully' : 'Schedule Events added successfully');
                    props.onClose && props.onClose();
                } else {
                    showToast && showToast(response.message || 'Something went wrong');
                }
            } else {
                showToast && showToast('Something went wrong');
            }
        } catch (error) {
            showToast && showToast(error.message || 'Failed to save schedule event');
        } finally {
            setBtnLoader(false);
        }
    };

    const valueChanged = (ev) => {
        const { name, value } = ev.target;
        if (name == 'scheduleEventLinkedEventID') {
            setState((st) => ({ ...st, [name]: value, scheduleEventStartEventLabel: '', scheduleEventEndEventLabel: '' }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
        setErrors({});
    };

    const yesNoClicked = (val) => (ev) => {
        const txt = (ev.target.textContent || ev.target.innerText || '').trim().toUpperCase();
        const isYes = txt === 'YES';
        switch (val) {
            case 1:
                setState((st) => ({ ...st, scheduleEventDisplayInspectionLink: isYes }));
                break;
            case 2:
                setState((st) => ({ ...st, scheduleEventDisplayResult: isYes }));
                break;
            case 3:
                setState((st) => ({ ...st, scheduleEventCreateNewEvent: isYes }));
                break;
            case 4:
                setState((st) => ({ ...st, scheduleEventDisplayPreviousDefects: isYes }));
                break;
            case 5:
                setState((st) => ({ ...st, scheduleEventCopyTyreData: isYes }));
                break;
            case 6:
                setState((st) => ({ ...st, scheduleEventIs2ndSignOffRequired: isYes }));
                break;
            default:
                break;
        }
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel shrink required>
                        Event Type
                    </InputLabel>
                    <SelectBox
                        name="scheduleEventInternalType"
                        value={state.scheduleEventInternalType || ''}
                        onChange={valueChanged}
                        List={state.dropList?.eventInternalTypes || []}
                    />
                    <FormHelperText error>{errors.scheduleEventInternalType ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={8} className="mandatory-fields">
                    <InputLabel shrink required>
                        Event Name
                    </InputLabel>
                    <TextBox size="small" margin="none" name="scheduleEventName" value={state.scheduleEventName || ''} onChange={valueChanged} />
                    <FormHelperText error>{errors.scheduleEventName ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel required shrink>
                        First Event
                    </InputLabel>
                    <SelectBox name="scheduleEventFirstEvent" value={state.scheduleEventFirstEvent || ''} onChange={valueChanged} List={firstEventList} />
                    <FormHelperText error>{errors.scheduleEventFirstEvent ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel shrink required>
                        Time To First Event
                    </InputLabel>
                    <TextBox size="small" margin="none" name="scheduleEventTimeToFirst" value={state.scheduleEventTimeToFirst || ''} onChange={valueChanged} />
                    <FormHelperText error>
                        {errors.scheduleEventTimeToFirstN ? 'Negative value not allowed' : errors.scheduleEventTimeToFirst ? 'This field is required' : null}
                    </FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel required shrink>
                        Interval Period
                    </InputLabel>
                    <SelectBox
                        name="scheduleEventIntervalPeriodCode"
                        value={state.scheduleEventIntervalPeriodCode || ''}
                        onChange={valueChanged}
                        List={state.dropList.eventIntervalPeriods || []}
                    />
                    <FormHelperText error>{errors.scheduleEventIntervalPeriodCode ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel required shrink>
                        Next Event
                    </InputLabel>
                    <SelectBox name="scheduleEventNextEvent" value={state.scheduleEventNextEvent || ''} onChange={valueChanged} List={nextEventList} />
                    <FormHelperText error>{errors.scheduleEventNextEvent ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel shrink required>
                        Event Interval
                    </InputLabel>
                    <TextBox size="small" margin="none" name="scheduleEventInterval" value={state.scheduleEventInterval || ''} onChange={valueChanged} />
                    <FormHelperText error>
                        {errors.scheduleEventIntervalN
                            ? 'Negative value not allowed'
                            : errors.bothNeeded
                            ? 'Both Event Interval and Event Miles Due can not be empty at same time'
                            : null}
                    </FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Event Miles Due</InputLabel>
                    <TextBox size="small" margin="none" name="scheduleEventMilesDue" value={state.scheduleEventMilesDue || ''} onChange={valueChanged} />
                    <FormHelperText error>
                        {errors.scheduleEventMilesDueN
                            ? 'Negative value not allowed'
                            : errors.bothNeeded
                            ? 'Both Event Interval and Event Miles Due can not be empty at same time'
                            : null}
                    </FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel required shrink>
                        Allowed Day Range
                    </InputLabel>
                    <SelectBox
                        insertEmpty={false}
                        name="scheduleEventDayRange"
                        value={state.scheduleEventDayRange}
                        onChange={valueChanged}
                        List={state.allowedDayRangeList || []}
                    />
                    <FormHelperText error>{errors.scheduleEventDayRange ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel required shrink>
                        VMRS Category
                    </InputLabel>
                    <SelectBox name="vmrsCategory" value={state.vmrsCategory || ''} onChange={valueChanged} List={state.dropList?.vmrsCategory || []} />
                    <FormHelperText error>{errors.vmrsCategory ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel required shrink>
                        VMRS Sub Category
                    </InputLabel>
                    <SelectBox name="vmrsSubCategory" value={state.vmrsSubCategory || ''} onChange={valueChanged} List={state.vmrsSubCategoryList || []} />
                    <FormHelperText error>{errors.vmrsSubCategory ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className="mandatory-fields">
                    <InputLabel shrink required>
                        Inspection Type
                    </InputLabel>
                    <SelectBox
                        name="scheduleEventInspectionTypeID"
                        value={state.scheduleEventInspectionTypeID || ''}
                        onChange={valueChanged}
                        List={state.dropList?.inspectionSheetDocs || []}
                    />

                    <FormHelperText error>{errors.scheduleEventInspectionTypeID ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Standard Lines</InputLabel>
                    <SelectBox
                        name="scheduleEventStandardLineID"
                        value={state.scheduleEventStandardLineID || ''}
                        onChange={valueChanged}
                        List={state.dropList.standardLines || []}
                    />
                    <FormHelperText error>{errors.scheduleEventStandardLineID ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Display Result on Completion?</InputLabel>
                    <Grid container item spacing={1}>
                        <Grid item xs={4} md={4}>
                            <YesButton name="scheduleEventDisplayResult" state={state.scheduleEventDisplayResult} data={true} onClick={yesNoClicked(2)} />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <NoButton name="scheduleEventDisplayResult" state={state.scheduleEventDisplayResult} data={false} onClick={yesNoClicked(2)} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Create New Event on Completion?</InputLabel>
                    <Grid container item spacing={1}>
                        <Grid item xs={4} md={4}>
                            <YesButton name="scheduleEventCreateNewEvent" state={state.scheduleEventCreateNewEvent} data={true} onClick={yesNoClicked(3)} />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <NoButton name="scheduleEventCreateNewEvent" state={state.scheduleEventCreateNewEvent} data={false} onClick={yesNoClicked(3)} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Display Previous Defects?</InputLabel>
                    <Grid container item spacing={1}>
                        <Grid item xs={4} md={4}>
                            <YesButton
                                name="scheduleEventDisplayPreviousDefects"
                                state={state.scheduleEventDisplayPreviousDefects}
                                data={true}
                                onClick={yesNoClicked(4)}
                            />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <NoButton
                                name="scheduleEventDisplayPreviousDefects"
                                state={state.scheduleEventDisplayPreviousDefects}
                                data={false}
                                onClick={yesNoClicked(4)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Copy Tyre Data? </InputLabel>
                    <Grid container item spacing={1}>
                        <Grid item xs={4} md={4}>
                            <YesButton name="scheduleEventCopyTyreData" state={state.scheduleEventCopyTyreData} data={true} onClick={yesNoClicked(5)} />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <NoButton name="scheduleEventCopyTyreData" state={state.scheduleEventCopyTyreData} data={false} onClick={yesNoClicked(5)} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>2nd Sign Off Required?</InputLabel>
                    <Grid container item spacing={1}>
                        <Grid item xs={4} md={4}>
                            <YesButton
                                name="scheduleEventIs2ndSignOffRequired"
                                state={state.scheduleEventIs2ndSignOffRequired}
                                data={true}
                                onClick={yesNoClicked(6)}
                            />
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <NoButton
                                name="scheduleEventIs2ndSignOffRequired"
                                state={state.scheduleEventIs2ndSignOffRequired}
                                data={false}
                                onClick={yesNoClicked(6)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Linked Event</InputLabel>
                    <SelectBox
                        name="scheduleEventLinkedEventID"
                        value={state.scheduleEventLinkedEventID || ''}
                        onChange={valueChanged}
                        List={state.dropList?.linkedEvents || []}
                    />
                </Grid>

                <Grid item xs={12} sm={4} className={state.scheduleEventLinkedEventID ? 'mandatory-fields' : ''}>
                    <InputLabel shrink required={state.scheduleEventLinkedEventID ? true : false}>
                        Start Event Label
                    </InputLabel>
                    <TextBox
                        size="small"
                        margin="none"
                        name="scheduleEventStartEventLabel"
                        value={state.scheduleEventStartEventLabel || ''}
                        onChange={valueChanged}
                    />
                    <FormHelperText error>{errors.scheduleEventStartEventLabel ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4} className={state.scheduleEventLinkedEventID ? 'mandatory-fields' : ''}>
                    <InputLabel required={state.scheduleEventLinkedEventID ? true : false} shrink>
                        End Event Label
                    </InputLabel>
                    <TextBox
                        size="small"
                        margin="none"
                        name="scheduleEventEndEventLabel"
                        value={state.scheduleEventEndEventLabel || ''}
                        onChange={valueChanged}
                    />
                    <FormHelperText error>{errors.scheduleEventEndEventLabel ? 'This field is required' : null}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <InputLabel shrink>Display Customer Declaration</InputLabel>
                    <SelectBox
                        name="scheduleEventDisplayCustomerDeclaration"
                        value={state.scheduleEventDisplayCustomerDeclaration || ''}
                        onChange={valueChanged}
                        insertEmpty={false}
                        List={state.customerDeclarationList}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5" color="secondary">
                                Reminder
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputLabel shrink>Before due</InputLabel>
                            <TextBox
                                size="small"
                                margin="none"
                                name="scheduleEventReminderInterval"
                                value={state.scheduleEventReminderInterval || ''}
                                onChange={valueChanged}
                            />
                            <FormHelperText error>{errors.scheduleEventReminderInterval ? 'This field is required' : null}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputLabel shrink>Period</InputLabel>
                            <SelectBox
                                name="scheduleEventReminderPeriodCode"
                                value={state.scheduleEventReminderPeriodCode || ''}
                                onChange={valueChanged}
                                List={state.dropList.eventIntervalPeriods || []}
                            />
                            <FormHelperText error>{errors.scheduleEventReminderPeriodCode ? 'This field is required' : null}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputLabel shrink>Mileage before due</InputLabel>
                            <TextBox
                                size="small"
                                margin="none"
                                name="scheduleEventReminderMilesDue"
                                value={state.scheduleEventReminderMilesDue || ''}
                                onChange={valueChanged}
                            />
                            <FormHelperText error>{errors.scheduleEventReminderMilesDue ? 'This field is required' : null}</FormHelperText>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <InputLabel shrink>Documents Required</InputLabel>
                    <Multiselect
                        name="eventDocsIds"
                        placeholder="Documents Required"
                        options={state.dropList?.eventDocs || []}
                        value={selectedData.multi || []}
                        onChange={multiChange}
                    />
                </Grid>

                <Grid item xs={12} className="submit_btn">
                    <SecondaryButton isBtnLoader={btnLoader} onClick={handleData} fullWidth>
                        {!props.selectedRowData?.scheduleEventID ? 'ADD' : 'UPDATE'}
                    </SecondaryButton>
                </Grid>
            </Grid>
        </>
    );
};
export default ScheduleEventDialog;
